import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderManualDeliveryAddressWrite } from './OrderManualDeliveryAddressWrite'
/**
* Class UpdateOrderDeliveryManual
*  Ручная доставка: произвольный адрес.
*/
export class UpdateOrderDeliveryManual extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'Manual' })
  readonly kind: string = 'Manual'


  /**
  * deliveryMethodId
  * Идентификатор способа из каталога канала.  */
  @ActiveField(0)
  deliveryMethodId: number = 0


  /**
  * deliverTo
  * Адрес назначения.  */
  @ActiveField({
    factory: [OrderManualDeliveryAddressWrite, () => undefined]
  })
  deliverTo?: OrderManualDeliveryAddressWrite
}
